import React from 'react'
import PropTypes from 'prop-types'

import CloseIconSVG from 'component/svgComponents/close'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import Select from 'component/Select/Select'

const INITIAL_STATE = {
    idBranch: "",
    status: "2"
}

class SideFilterForm extends React.Component {
  static propTypes = {
    closeFilter: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    initialValues: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    isUserMatriz: PropTypes.bool.isRequired,
    missionsSelectBranchs: PropTypes.array
    
  }

  state = {
    values: {
      idBranch: '',
      dtPeriod: [],
      status: '2',
    },
    previousValues: {
      idBranch: '',
      dtPeriod: [],
      status: '2'
    }
  }

  get statusOptions() {
    const { translate } = this.props

    const options = [
      {
        label: translate('irc.all'),
        value: '2',
      },
      {
        label: translate('irc.active'),
        value: '1',
      },
      {
        label: translate('irc.inactive'),
        value: '0',
      },
    ]

    return options
  }

  handleSubmit = () => {
    const { values } = this.state
    const { onSubmit } = this.props

    this.setState({
      previousValues: values
    })

    onSubmit(values)
  }

  handleChange(field, value) {
    this.setState({
      values: {
        ...this.state.values,
        [field]: value,
      }
    })
  }

  hasRequiredEmpty() {
    const { values } = this.state
    let has = false

    const fields = ['idBranch', 'dtPeriod']

    fields.forEach(field => {
      if (values[field].length === 0) has = true
    })

    return has
  }

  sameValues() {
    const { values, previousValues } = this.state
    let sameValues = true

    const fields = ['idBranch', 'status']

    fields.forEach(field => {
      if (values[field] !== previousValues[field]) sameValues = false
    })

    const allDateIsEmpty = !values.dtPeriod.length && !previousValues.dtPeriod.length
    const hasOneEmpty = !values.dtPeriod.length || !previousValues.dtPeriod.length

    if (!allDateIsEmpty && hasOneEmpty) {
      sameValues = false
    } else if (!allDateIsEmpty && !hasOneEmpty) {
      if (
        previousValues.dtPeriod[0].format('DD/MM/YYYY') !== values.dtPeriod[0].format('DD/MM/YYYY')
        || previousValues.dtPeriod[1].format('DD/MM/YYYY') !== values.dtPeriod[1].format('DD/MM/YYYY')
      ) {
        sameValues = false
      }
    }

    return sameValues
  }

  cleanFilters = () => {
    const {values} = this.state
    const currentValue = {...values}
    this.setState({
      previousValues: currentValue,
      values: {...currentValue, ...INITIAL_STATE}
    })
  }

  render() {
    const {
      translate,
      closeFilter,
      show,
      isUserMatriz,
      missionsSelectBranchs,
      auth: { user }
    } = this.props
    const { values } = this.state

    return (
      <div className={`common-report no-margin no-padding h-0`}>
        <div className='content'>
          <div
            className={`filters-overlay ${show ? 'show' : ''
              }`}
          />
          <div
            className={`filters fixed ${show ? 'open' : ''
              }`}
          >
            <div className='close' onClick={closeFilter}>
              <CloseIconSVG />
            </div>
            <h3 className='no-margin'>
              <strong>{translate('mobile.filter')}</strong>
            </h3>

            <div className='margin-bottom-double' />

            <div>
                <RegionBranchMultipleSelect
                required
                name='idBranch'
                label={translate('irc.store')}
                placeholder={"Selecione uma ou mais lojas"}
                user={user}
                translate={translate}
                onChange={(e) => this.handleChange('idBranch', e.target.value)}
                value={ !isUserMatriz ? (Array.isArray(missionsSelectBranchs) && missionsSelectBranchs.includes(user.title) ? values.idBranch : [{ value: user.locationCode.padStart(4, '0') }] ): values.idBranch}
                disabled={!isUserMatriz}
              />
            </div>

            <div>
              <Select
                fill
                required
                label={translate('status')}
                options={this.statusOptions}
                onChange={(e) => this.handleChange('status', e.value)}
                value={this.statusOptions.find(({ value }) => value === values.status)}
                validateValue={(v) => (v.value || '').length > 0}
              />
            </div>

            <div>
              <NewDateIntervalInput
                required
                user={user}
                disableRange={true}
                validate={false}
                label={translate('field.period.hint')}
                name='dtPeriod'
                t={translate}
                onChange={(e) => this.handleChange('dtPeriod', e)}
                
              />
            </div>
            
            <div className='irc-supply-list-filter'>
              <button
              className='btn btn-danger-outline button-full margin-top-double'
              
              onClick={this.cleanFilters}
              type='button'
              >
              {translate('suggestions.cleanFilters')}
              </button>
              
                <button
                  className='btn btn-primary button-full margin-top-double'
                  onClick={this.handleSubmit}
                  disabled={this.sameValues() || this.hasRequiredEmpty()}
                  type='button'
                >
                  {translate('btn.filter')}
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default SideFilterForm
export { SideFilterForm }
